import PizZipUtils from 'pizzip/utils/index.js';
export const loadFilePZip = (url: string, callback: any) => {
  PizZipUtils.getBinaryContent(url, callback);
};
